function init() {

  const nav = document.querySelector('#navigation-primary');

  if (!nav) {
    return;
  }

  const buttons = document.querySelectorAll('.menu-item-has-children');

  if(!buttons.length){
    return;
  }

  Array.from(buttons).forEach((button) => {
    buildMenu(button);
  });
  
}

function buildMenu(button) {
  button.querySelector('a').addEventListener('click', function (e) {
    e.preventDefault()
    setActive(button);
  })
}

function setActive(item) {
  const menu = item.querySelector('.sub-menu');
  const menuItems = item.querySelectorAll('li');

  if (item.classList.contains('open')) {
    menu.style.height = '0px';
    item.classList.remove('open');
  } else {
    let combinedHeight = 0;
    Array.from(menuItems).forEach((menuItem) => {
      const { height } = menuItem.getBoundingClientRect();
      combinedHeight = combinedHeight + height
    });
    menu.style.height = `${combinedHeight}px`;
    item.classList.add('open');
  }
}

export default init
